<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/juhan.png" alt="巨航" />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0,0)"
          :text-color="navBackground"
          :active-text-color="navBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首页</el-menu-item>

          <el-submenu
            v-for="(item, index) in routers"
            :key="index"
            :index="`${index}`"
            popper-class="menu1"
          >
            <template slot="title">{{ item.title }}</template>
            <el-menu-item
              v-for="(rData, i) in item.subRouters"
              :key="`sub${i}`"
              :index="rData.index"
              class="menu_item"
              >{{ rData.title }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
        <!-- <a href="#">立即体验</a> -->
        <!-- <span class="right_phone">
          <i class="el-icon-phone"></i>
          <span> 000-000-0000 </span>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      navBackground: '#fff',
      routers: [],
      routerMap: new Map()
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '0',
    },
  },
  mounted() {
    this.initData()
    this.activeIndex = this.selectIndex
    window.onscroll = () => {
      if (document.documentElement.scrollTop > 390) {
        this.navBackground = '#000'
      } else {
        this.navBackground = '#fff'
      }
    }
  },
  methods: {
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH
      console.log("baseUrl", process.env.VUE_APP_PUBLIC_PATH)
      fetch(baseUrl + '/home/data.json')
        .then(response => response.json())
        .then(data => {
          let { routers } = data
          this.routers = routers

          let map = new Map()
          routers.forEach(item => {
            map.set(item.index, item.path)

            if (item.subRouters) {
              item.subRouters.forEach(i => {
                map.set(i.index, i.path)
              })
            }
          })
          this.routerMap.clear()

          this.routerMap = map

        })
        .catch(error => console.error('Error loading JSON:', error));
    },
    changeCurrentPage(index) {
      this.activeIndex = index
      console.log(this.activeIndex, "this.activeIndex")

      if (this.activeIndex == "1") {
        this.$router.push('/home').catch((v) => { })
      } else {
        let path = this.routerMap.get(index)

        console.log(index, path, "this.activeIndex**")

        this.$router.push(path).catch((v) => { })
      }

      return
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: rgba(64, 158, 255, 0.5);
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 160px;
        cursor: pointer;
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }
      .right_phone {
        &:hover {
          color: #ccc;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #fff;
      }
    }
  }
}
</style>
<style lang="scss">
$subColor: green;
$menuActiveText: #000;
$menuText: #000;
$menuBg: #7faee0;

.el-menu--popup {
  background: $menuBg !important;
}
// 修改弹出层激活的样式
.el-menu--popup > div:has(.is-active) {
  background-color: $subColor !important;
  border-left: 2px solid #ed1c24 !important;
}
.el-menu--popup-bottom-start {
  background: $menuBg !important;
}
// 修改弹出层hover样式
.el-menu--popup > div:has(.el-menu-item) :hover {
  background-color: $subColor !important;
  border-left: 2px solid #ed1c24 !important;
  color: $menuActiveText !important;
}

.el-menu--vertical {
  & > .el-menu {
    .svg-icon {
      margin-right: 16px;
    }
  }

  .nest-menu .el-sub-menu > .el-sub-menu__title,
  .el-menu-item {
    &:hover {
      // you can use $sub-menuHover
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
  }

  // the scroll bar appears when the sub-menu is too long
  > .el-menu--popup {
    max-height: 100vh;
    overflow-y: auto;

    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
  }

  // 修改element菜单的样式
  // .el-menu {
  //     border: none;
  //     height: 100%;
  //     width: 100%;
  //     background-color: $menuBg !important;

  //     .el-menu-item {
  //       background-color: $menuBg !important;
  //       color: $menuText !important;
  //       &:hover {
  //         background-color: $subColor !important;
  //         border-left: 2px solid #ed1c24 !important;
  //         color: $menuActiveText !important;
  //       }
  //       &.is-active {
  //         background-color: $subColor !important;
  //         border-left: 2px solid #ed1c24 !important;
  //         color: $menuActiveText !important;
  //       }
  //     }

  //     .el-submenu__title {
  //       background-color: $menuBg !important;
  //       &:hover {
  //         background-color: $subColor !important;
  //         border-left: 2px solid #ed1c24;
  //         color: $menuActiveText !important;
  //       }
  //     }

  //     .el-submenu.is-active > .el-submenu__title {
  //       color: $menuText !important;
  //       &:hover,
  //       &:hover > i {
  //         color: $menuActiveText !important;
  //       }
  //     }

  //     .submenu-title-noDropdown,
  //     .el-submenu__title {
  //       border-bottom: 1px solid rgba(201, 211, 213, 0.3) !important;
  //     }
  //     .el-menu--inline > div {
  //       border-bottom: 1px dashed rgba(201, 211, 213, 0.7) !important;
  //     }
  //   }
}
</style>